import React from "react";
import {useField} from "formik";
import Select, {SingleValue} from "react-select";
import {SelectOption} from "../types/SelectOption";

interface FormSelectPropsI {
    name: string,
    options: SelectOption[],
    isDisabled?: boolean,
    id?: string
}


const FormSelect: React.FC<FormSelectPropsI> = (props) => {

    const [field, _, helpers] = useField(props.name);

    return (
        <Select
            className="blj-store-locator__form-select"
            inputId={props.id}
            options={props.options}
            placeholder="Select the search radius..."
            isSearchable={false}
            isClearable={false}
            isDisabled={props.isDisabled}
            {...field}
            onChange={
                (option: SingleValue<SelectOption>) => {
                    helpers.setValue(option)
                }
            }
        />
    )
}

export default FormSelect;